import { render, staticRenderFns } from "./Shell.vue?vue&type=template&id=a7015502&scoped=true&"
import script from "./Shell.vue?vue&type=script&lang=js&"
export * from "./Shell.vue?vue&type=script&lang=js&"
import style0 from "./Shell.vue?vue&type=style&index=0&id=a7015502&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7015502",
  null
  
)

export default component.exports